<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="1" finish-status="success" simple>
          <el-step :title=Selectionofparameters></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <img class="electricImg" :src=picUrl alt="">
          </div>
        </el-col>
        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              <h3>{{$t('message.ReducerModel')}} <span style="font-size:14px;color:red;">{{$t('message.Info')}}</span></h3>
              <h4>{{ reducer_type }}</h4>
              <div style="padding-top:30px;">
                <span class="button" @click="renturnPrePage">{{$t('message.Return')}}</span>
                <router-link to="./">
                  <span class="button" style="margin-left:15px;">{{$t('message.returnIndex')}}</span>
                </router-link>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 下载规格书·外形图 & 资料页-->
    <div class="elec_detail">
      <el-row>
        <el-col :span="24">
          <h2>{{$t('message.Dso')}}</h2>
        </el-col>
        <el-col :span="24" style="padding-top:30px;font-weight:bold;text-align:center;">
          <el-col :span="8">PDF<el-button style="margin-left:15px;" @click="_downloadPDF()">{{$t('message.clickDownload')}}</el-button></el-col>
          <el-col :span="8">STP <el-button style="margin-left:15px;" @click="_downloadSTP()">{{$t('message.clickDownload')}}</el-button></el-col>
          <el-col :span="8">DWG <el-button style="margin-left:15px;" @click="_downloadDWG()">{{$t('message.clickDownload')}}</el-button></el-col>
        </el-col>

        <el-col :span="24" style="padding-top:20px;">
          <h2>{{$t('message.Information')}}</h2>
          <el-collapse v-model="activeNames" style="background:#FCFCFC;">
            <el-collapse-item :title=DecelerationDimensionDetails name="1">
              <el-row class="card_box">
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_1')}}</el-col>
                  <el-col :span="12" class="item_value">{{ reduction_ratio }}</el-col>
                </el-col>
                 <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_2')}}</el-col>
                  <el-col :span="12" class="item_value">{{ torsional_rigidity }}Nm/arcmin</el-col>
                </el-col>
                <!-- <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">级数</el-col>
                  <el-col :span="12" class="item_value">{{ reducer_level }}</el-col>
                </el-col> -->

                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_3')}}</el-col>
                  <el-col :span="12" class="item_value">{{ fault_stop_torque }}Nm</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_4')}}</el-col>
                  <el-col :span="12" class="item_value">{{ max_axial_force }}N</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_5')}}</el-col>
                  <el-col :span="12" class="item_value">{{ max_radial_force }}N</el-col>
                </el-col>

                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_6')}}</el-col>
                  <el-col :span="12" class="item_value">{{ max_speed }}r/min</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_7')}}</el-col>
                  <el-col :span="12" class="item_value">{{ rated_speed }}r/min</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_8')}}</el-col>
                  <el-col :span="12" class="item_value">{{ moment_of_inertia }}kgcm²</el-col>
                </el-col>

                <el-col :span="8" class="card_box_item">
                  <el-col :span="16" class="item_title">{{$t('message.finish_9')}}</el-col>
                  <el-col :span="8" class="item_value">{{ rated_output_torque }}Nm</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_10')}}</el-col>
                  <el-col :span="12" class="item_value">{{ average_life }}h</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">{{$t('message.finish_11')}}</el-col>
                  <el-col :span="12" class="item_value">{{ full_load_efficiency }}%</el-col>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <!-- <el-collapse v-model="activeNames_2" style="background:#FCFCFC;">
            <el-collapse-item title="安装电机" name="1">
              <el-row class="card_box">
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">厂商</el-col>
                  <el-col :span="12" class="item_value">{{ motor_factory }}</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">型号</el-col>
                  <el-col :span="12" class="item_value">{{ motor_type }}</el-col>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="activeNames_3" style="background:#FCFCFC;">
            <el-collapse-item title="电机规格" name="1">
              <el-row class="card_box">
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">额定输出扭矩</el-col>
                  <el-col :span="12" class="item_value">{{ rated_torque }}</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">功率</el-col>
                  <el-col :span="12" class="item_value">{{ power }}</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">转动惯量</el-col>
                  <el-col :span="12" class="item_value">{{ moment_of_inertia }}</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">额定转速</el-col>
                  <el-col :span="12" class="item_value">{{ rated_revolution }}</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">最高转速 </el-col>
                  <el-col :span="12" class="item_value">{{ maximum_revolution }}</el-col>
                </el-col>
                <el-col :span="8" class="card_box_item">
                  <el-col :span="12" class="item_title">轴直径 </el-col>
                  <el-col :span="12" class="item_value">{{ diameter }}</el-col>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse> -->
          <el-collapse v-model="activeNames_4" style="background:#FCFCFC;">
            <el-collapse-item :title=notes name="1" class="attention">
              <p>{{$t('message.info08')}}</p>
              <p>{{$t('message.info09')}}</p>
              <p>{{$t('message.info10')}}</p>
              <p>{{$t('message.info11')}}</p>
              <!-- <img style="width:400px;height:170px;padding:20px 0 20px 50px;" src="../../../static/electric.png" alt=""> -->
            </el-collapse-item>
          </el-collapse>
          <!-- <el-col :span="24" style="width:100%;text-align:center;">
                <span class="button" @click="renturnPrePage">{{$t('message.Return')}}</span>
                <router-link to="./">
                  <span class="button" style="margin-left:15px;">{{$t('message.returnIndex')}}</span>
                </router-link>
              </el-col> -->
        </el-col>
      </el-row>
    </div>
    <!-- 弹出层 -->
        <el-dialog
          :title=tips
          :visible.sync="infoDialog"
          width="25%"
          center>
          <el-form :model="infoForm" :rules="rules" ref="ruleForm" label-width="115px" class="ruleForm">
            <el-form-item :label=name prop="name">
              <el-input v-model="infoForm.name" style="width:280px;"></el-input>
            </el-form-item>
            <el-form-item :label=tel prop="tel">
              <el-input v-model="infoForm.tel" style="width:280px;"></el-input>
            </el-form-item>
            <el-form-item :label=email prop="mail">
              <el-input v-model="infoForm.mail" style="width:280px;"></el-input>
            </el-form-item>
            <el-form-item :label=company prop="company">
              <el-input v-model="infoForm.company" style="width:280px;"></el-input>
            </el-form-item>
            <el-form-item :label=seriesofinterest prop="series">
              <el-input v-model="infoForm.series" style="width:280px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm',infoForm)">{{$t('message.submit')}}</el-button>
              <el-button @click="resetForm('ruleForm')">{{$t('message.reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
  </div>
</template>
<script>
  import {
    getinfobyreducersize
  } from '@/store/electric_param'
  import {
    downloadPDF,
    downloadSTP,
    downloadDWG,
    sendEmail
  } from '@/store/electric_download'
  export default {
    name: 'SelectedDeceleration',
    data() {
      return {
        infoForm: {
          name: '',
          tel: '',
          mail: '',
          company: '',
          series: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入(please enter)', trigger: 'blur' },
            { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '格式有误!(incorrectformat!)' }
          ],
          tel: [
            { required: true, message: '请输入(please enter)', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '格式有误!(incorrect format!)' }
          ],
          mail:[
            { pattern: /[^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/, message: '格式有误!(incorrectformat!)' }
          ]
        },
        download_param: '',
        infoDialog: false,
        activeNames: ['1'],
        activeNames_2: ['1'],
        activeNames_3: ['1'],
        activeNames_4: ['1'],
        reducer_size:'',
        reducer_type:'',
        reducer_size_2:'',
        reduction_ratio:'',
        reducer_series_name:'',
        specifications:'',
        max_axial_force:'',
        max_radial_force:'',
        max_speed:'',
        rated_speed:'',
        moment_of_inertia:'',
        noise:'',
        average_life:'',
        full_load_efficiency:'',
        motor_factory:'',
        motor_type:'',
        rated_torque:'',
        power:'',
        moment_of_inertia:'',
        rated_revolution:'',
        maximum_revolution:'',
        diameter:'',
        torsional_rigidity:'',
        reducer_level:'',
        fault_stop_torque:'',
        rated_output_torque:'',
        param_completed:{},
        picUrl:'',
        param_download:{},
        Selectionofparameters:this.$t('message.Selectionofparameters'),
        complete:this.$t('message.complete'),
        DecelerationDimensionDetails:this.$t('message.DecelerationDimensionDetails'),
        InstallMotor : this.$t('message.InstallMotor'),
        motorSpecifications : this.$t('message.motorSpecifications'),
        notes : this.$t('message.notes'),
        tips : this.$t('message.tips'),
        tel : this.$t('message.tel'),
        name : this.$t('message.name'),
        email : this.$t('message.email'),
        company : this.$t('message.company'),
        seriesofinterest : this.$t('message.seriesofinterest'),
        incorrectformat : this.$t('message.incorrectformat'),
        pleaseenter : this.$t('message.pleaseenter')
      }
    },
    props: {
      param:{},
      required: true
    },
    methods: {
      renturnPrePage:function(){
        this.$emit("listenPageChange","to_MotorPage");
      },
      _getinfobyreducersize:function(data){
        getinfobyreducersize(data).then((response) => {
          //this.reducer_type = data.reducer_type;
          if (response.success === true) {
            // 需求337 修改文件后缀 -- begin
            this.reducer_type = response.data.reducer_type2;
            // this.reducer_type = `${response.data.specifications}-${response.data.reduction_ratio}-${response.data.motor_size}`;
            // 需求337 修改文件后缀 -- end
            this.reduction_ratio = response.data.reduction_ratio;
            this.max_axial_force = response.data.max_axial_force;
            this.max_radial_force = response.data.max_radial_force;
            this.max_speed = response.data.max_speed;
            this.rated_speed = response.data.rated_speed;
            this.moment_of_inertia = response.data.moment_of_inertia;
            this.average_life = response.data.average_life;
            this.full_load_efficiency = response.data.full_load_efficiency;
            this.torsional_rigidity = response.data.torsional_rigidity;
            this.reducer_level = response.data.reducer_level;
            this.fault_stop_torque = response.data.fault_stop_torque;
            this.rated_output_torque = response.data.rated_output_torque;
            this.picUrl = response.data.outlook_picture	;

            // 下载相关
            //this.param_download.reducer_type = response.data.reducer_type;
            this.param_download.reducer_type = data.reducer_type;
            this.param_download.reducer_type2 = response.data.reducer_type2;
            // this.param_download.reducer_type2 = `${response.data.specifications}-${response.data.reduction_ratio}-${response.data.motor_size}`;
            this.param_download.specifications = response.data.specifications;
            this.param_download.reduction_ratio = response.data.reduction_ratio;
            //this.param_download.level = response.data.reducer_level;
            this.param_download.rated_output_torque = response.data.rated_output_torque;
            this.param_download.fault_stop_torque = response.data.fault_stop_torque;
            this.param_download.max_radial_force = response.data.max_radial_force;
            this.param_download.max_axial_force = response.data.max_axial_force;
            this.param_download.full_load_efficiency = response.data.full_load_efficiency;
            this.param_download.moment_of_inertia = response.data.moment_of_inertia;
            this.param_download.max_speed = response.data.max_speed;
            this.param_download.rated_speed = response.data.rated_speed;
            this.param_download.average_life = response.data.average_life;
            this.param_download.noise = response.data.noise;
            this.param_download.mass = response.data.mass;
            this.param_download.clearance_precision = response.data.clearance_precision;
            this.param_download.clearance_standard = response.data.clearance_standard;
            this.param_download.torsional_rigidity = response.data.torsional_rigidity;
            this.param_download.is_with_key = response.data.is_with_key;
          }
        })
      },
      /* 中文版 */
      _downloadPDF:function(){
        const data = localStorage.getItem('infoForm');
        console.log(data)
        this.download_param = 'pdf'
        // 如果是英文版，直接下载，中文则显示弹窗
        // if(localStorage.getItem('lang') == 'cn'){
        //   this.infoDialog = true;
        //   this.infoForm.name = '';
        //   this.infoForm.tel = '';
        //   this.infoForm.mail = '';
        //   this.infoForm.company = '';
        //   this.infoForm.series = '';
        // }else {
          downloadPDF(this.param_download)
        // }
      },
      _downloadSTP:function(){
        const data = localStorage.getItem('infoForm');
        this.download_param = 'stp'
        // 如果是英文版，直接下载，中文则显示弹窗
        // if(localStorage.getItem('lang') == 'cn'){
        //   // this.infoDialog = true;
        //   this.infoForm.name = '';
        //   this.infoForm.tel = '';
        //   this.infoForm.mail = '';
        //   this.infoForm.company = '';
        //   this.infoForm.series = '';
        // }else {
          downloadSTP(this.param_download)
        // }
      },
      _downloadDWG:function(){
        const data = localStorage.getItem('infoForm');
        this.download_param = 'dwg'
        // 如果是英文版，直接下载，中文则显示弹窗
        // if(localStorage.getItem('lang') == 'cn'){
        //   // this.infoDialog = true;
        //   this.infoForm.name = '';
        //   this.infoForm.tel = '';
        //   this.infoForm.mail = '';
        //   this.infoForm.company = '';
        //   this.infoForm.series = '';
        // }else {
          downloadDWG(this.param_download)
        // }
      },
      submitForm(formName,data) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const info_string = `姓名: ${data.name};电话: ${data.tel};邮件: ${data.mail};公司名称: ${data.company};感兴趣的类型: ${data.series}`
            sendEmail(info_string)
            localStorage.setItem('infoForm', this.infoForm)
            this.infoDialog = false;
            console.log(this.param_download)
            if(this.download_param == 'pdf') {
              downloadPDF(this.param_download)
            }else if(this.download_param = 'stp') {
              downloadSTP(this.param_download)
            }else if(this.download_param = 'dwg') {
              downloadDWG(this.param_download)
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
      /* 英文版 */
      /* _downloadPDF:function(){
        downloadPDF(this.param_download);
      },
      _downloadSTP:function(){
        downloadSTP(this.param_download)
      },
      _downloadDWG:function(){
        downloadDWG(this.param_download)
      } */
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:25%;
    margin-left:50px;
    padding-top:25px;
  }
  .el-step.is-simple.is-flex{
    margin-right:8%;
  }
  .el-steps {
    border-radius:5px;
    background-color: #F5F7FA;
    background:url('../../../static/step_complete.png') no-repeat #F5F7FA;
    background-size:50% 100%;
    background-position-x:100%;
  }
  .elec_select_left img{
    width: 220px;
    height: 200px;
    display: block;
    margin: 0 auto;
    padding-top: 90px;
  }
  .elec_select_left .text {
    text-align: left;
    font-weight: bold;
    margin-left: 270px;
  }
  .elec_select_left .text h4 {
    padding-top:5px;
  }
  .elec_select_left .text h4 span{
    padding-left:30px;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:120px;
  }
  .select_box h3 {
    padding-bottom:20px;
  }
  .select_box h4 {
    padding-top:20px;
  }
  .toNextPage {
    width:139px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    display: inline-block;
    margin-left:40px;
  }
  .renturnPrePage {
    width:139px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    display: inline-block;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
  }
  .detail_img {
    width:150px;
    height:150px;
  }
  .detail_img_box {
    width:70%;
    margin:0 auto;
    padding-top:20px;
  }
  .radio_box {
    margin-top:50px;
  }
  .radio_box .el-radio {
    width:140px;
    height:70px;
    height:70px;
  }
  .downloadSpec {
    width:350px;
    height:115px;
    background-color: #F4F4F4;
    border-radius: 10px;
  }
  .downloadSpec h4 {
    text-align: center;
    padding-top:30px;
    font-weight: normal;
  }
  .downloadSpec .el-button {
    margin-top:15px;
  }
  .downloadSpec .button_first {
    margin-left:30px;
  }

  .card_box .card_box_item {
    width:32%;
    height: 74px;
    margin: 5px;
    margin-left: 8px;
    border:1px solid #ccc;
    border-radius: 8px;
    line-height: 74px;
    font-size: 14px;
    font-weight: 500;
  }
  .card_box_item .item_title {
    text-align: left;
    padding-left:14px;
  }
  .card_box_item .item_value {
    text-align: right;
    padding-right:14px;
  }
  .attention p{
    padding-left:50px;
    line-height:40px;
    font-size: 16px;
  }
  .attention img {
    padding-left:20px;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    background:#142479;
    border-radius: 10px;
    color:#F4F4F4;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    margin-bottom:40px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .card_box {
      margin-left:6px;
    }
    .card_box .card_box_item {
      width:31%;
      height: 74px;
      margin: 5px;
      margin-left:8px;
      border:1px solid #ccc;
      border-radius: 8px;
      line-height: 74px;
      font-size: 12px;
      font-weight: 500;
    }
    .card_box_item .item_title {
      text-align: left;
      padding-left:12px;
    }
    .card_box_item .item_value {
      text-align: right;
      padding-right:12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/MotorSelection/SelectedCompleted.vue